import { IconButton } from '@material-ui/core';
import cx from 'classnames';
import MuiButton from 'components/common/button/MuiButton';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import T from 'components/common/text/T';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';

import CheckIcon from '@material-ui/icons/Check';
import Color from 'color';

interface ProjectRemakeModalProps {
  remakeList: any;
  remake: number[];
  onSaveRemake: (selectedRemake: number[]) => void;
  onClose: () => void;
}

/**
 * @param {ProjectRemakeModalProps} { selectedPartner }
 * @return {*}
 */
function ProjectRemakeModal({
  remakeList,
  remake,
  onClose,
  onSaveRemake,
}: ProjectRemakeModalProps) {
  const [selectedRemake, setSelectedRemake] = useState<number[]>([]);

  const handleCheckRemake = (remakeTypeIdx: number) => {
    if (selectedRemake.includes(remakeTypeIdx)) {
      setSelectedRemake(selectedRemake.filter(item => item !== remakeTypeIdx));
    } else {
      setSelectedRemake((draft: any) => [...draft, remakeTypeIdx]);
    }
  };

  useEffect(() => {
    if (!!remake) {
      setSelectedRemake(remake);
    }
  }, [remake]);

  return (
    <StyledProjectRemakeModal data-component-name="ProjectRemakeModal">
      <div className="ProjectRemakeModal__container_wrapper">
        <div className="ProjectRemakeModal__title_container">
          <h1 className="ProjectRemakeModal__title_box">
            {/* <T>REWORK_TITLE</T> */}
            리메이크 항목을 선택하세요
          </h1>
          <div className="ProjectRemakeModal__title_underbar"></div>
        </div>
        <div className="ProjectRemakeModal__contents_container">
          {remakeList.map((remakeItem: any) => {
            return (
              <IconButton
                className={cx('ProjectRemakeModal__contents_box', {
                  checked: selectedRemake.includes(remakeItem.remakeTypeIdx),
                })}
                key={remakeItem.remakeTypeIdx}
                onClick={() => handleCheckRemake(remakeItem.remakeTypeIdx)}
              >
                <div
                  className={cx('ProjectRemakeModal__contents_check_box', {
                    checked: selectedRemake.includes(remakeItem.remakeTypeIdx),
                  })}
                >
                  <CheckIcon htmlColor="inherit" fontSize="inherit" />
                </div>
                <span className="ProjectRemakeModal__contents_name">
                  {remakeItem.remakeTypeName}
                </span>
              </IconButton>
            );
          })}
        </div>
      </div>
      <StyledPlainButtonOuter
        className="partnerModalInput__form_button_box detail"
        backgroundColor={color.navy_blue}
        left="50%"
        width={370}
        height={76}
      >
        <MuiButton
          config={{
            width: '320px',
          }}
          // disabled={buttonValid}
          disableElevation
          color="primary"
          variant="contained"
          disablebackground={color.navy_blue}
          disablefontcolor="#ffffff"
          className="xl border-radius-round partner_ok_button "
          // onClick={() => {
          //   handleSubmitPatientData(type);
          // }}
          onClick={() => onSaveRemake(selectedRemake)}
        >
          <T>GLOBAL_OK</T>
        </MuiButton>
      </StyledPlainButtonOuter>
    </StyledProjectRemakeModal>
  );
}

const StyledProjectRemakeModal = styled.section<{}>`
  position: relative;
  .ProjectRemakeModal__container_wrapper {
    width: 500px;
    height: 500px;
    margin-bottom: 30px;
    position: relative;
    background-color: #ffffff;
    border-radius: 15px;
    padding: 30px 0;

    .ProjectRemakeModal__title_container {
      position: relative;
      padding-bottom: 12px;
      text-align: center;
      .ProjectRemakeModal__title_box {
        color: #0f0f0f;
        font-size: 22px;
        font-weight: 700;
      }
      .ProjectRemakeModal__title_underbar {
        position: absolute;
        width: 80px;
        height: 2px;
        background-color: #1da7e0;
        transform: translate(-50%, -50%);
        left: 50%;
        bottom: 0;
      }
    }

    .ProjectRemakeModal__contents_container {
      margin-top: 60px;
      display: flex;
      /* flex-direction: column; */
      flex-wrap: wrap;
      justify-content: space-between;
      row-gap: 10px;
      padding: 0 40px;
      .ProjectRemakeModal__contents_box {
        position: relative;
        width: 205px;
        height: 50px;
        border: 1px solid #dddee4;
        border-radius: 5px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #444;
        &:hover {
          cursor: pointer;
        }
        .ProjectRemakeModal__contents_check_box {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          left: 15px;

          font-size: 12px;
          border: 1px solid #b5b7c1;
          border-radius: 50%;
          color: #444;
          display: flex;
          align-items: center;
          justify-content: center;
          &.checked {
            color: #00a6e2;
            background-color: #f7fcfe;
            border: 1px solid #00a6e2;
          }
        }
        .ProjectRemakeModal__contents_name {
          color: inherit;
        }
        &.checked {
          color: #00a6e2;
          background-color: #f7fcfe;
          border: 1px solid #00a6e2;
        }
      }
    }
  }
  .partnerModalRequest__button_container {
    .partnerModalRequest__button_box {
      position: relative;
      display: flex;
      .partnerModalRequest__cancel_button {
        position: relative;
        z-index: 2;
      }
      .partnerModalRequest__save_button {
        margin-left: -10px;
        background: rgb(0, 166, 226);
        background: linear-gradient(90deg, rgba(0, 166, 226, 1) 0%, rgba(8, 123, 238, 1) 100%);
        border: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        overflow: hidden;
        &:hover {
          background: ${`linear-gradient(
            90deg,
            ${Color('rgba(0, 166, 226, 1)').darken(0.12)} 0%,
            ${Color('rgba(8, 123, 238, 1)').darken(0.12)} 100%
          )`};
        }
        .btn-shadow-inset {
          position: absolute;
          top: -5px;
          left: -46px;
          width: 66px;
          height: 66px;
          border-radius: 33px;
          background-color: ${color.navy_blue};
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
        }
      }
    }
  }
`;

export default React.memo(ProjectRemakeModal);
